import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import '../../css/purchase-details-navbar.css';

class DetailsNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = { current: '' };
  }

  onChange(name, e) {
    this.setState({ current: name });
    this.props.onChange(name);
  }

  activeClassFor(element) {
    return this.state.current === element ? 'active' : '';
  }

  showingAlert() {
    const { isOrganizer, hasIssues } = this.props;
    if (!isOrganizer) return false;
    return hasIssues;
  }

  renderContributorsItem() {
    const alertIcon = <i className="coral-error fa fa-exclamation-circle mr-1" />;
    const content = (
      <span>
        {this.showingAlert() && alertIcon}
        {' '}
        <FormattedMessage
          id="detailsNavBar.contributors"
          defaultMessage="Contributors"
        />
      </span>
    );
    return this.renderItem('contributors', content);
  }

  renderDetailsItem() {
    const content = (
      <FormattedMessage
        id="detailsNavBar.detail"
        defaultMessage="Detail"
      />
    );
    return this.renderItem('details', content);
  }

  renderActivitiesItem() {
    const content = (
      <FormattedMessage
        id="detailsNavBar.activities"
        defaultMessage="Activity & messages"
      />
    );

    return this.renderItem('activities', content);
  }

  renderHoldoutsItem() {
    if (!this.props.hasHoldouts) return;
    const content = (
      <FormattedMessage
        id="detailsNavBar.holdouts"
        defaultMessage="Holdouts"
      />
    )
    return this.renderItem('holdouts', content);
  }

  renderItem(name, children) {
    const className = `nav-item mx-4 px-0 ${name} ${this.activeClassFor(name)}`;
    return (
      <li className={className}>
        <a className="nav-link px-1" href={`#nav-${name}`} onClick={(e) => { this.onChange(name, e); return false; }}>
          {children}
        </a>
      </li >
    );
  }

  render() {
    return (
      <div className="purchase-details-navbar sticky-top mb-4">
        <div className="row">
          <div className="col-12">
            <ul className="nav">
              {this.renderContributorsItem()}
              {this.renderHoldoutsItem()}
              {this.renderDetailsItem()}
              {this.renderActivitiesItem()}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

DetailsNavBar.defaultProps = {
  onChange: () => { },
};

export default DetailsNavBar;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/details-navbar.js